import BillingDashboard from '@/models/general/settings/BillingDashboard';

const getDefaultState = () => ({
  emails: [],
  maxEmails: 0,
});
export default {
  namespaced: true,

  state: () => getDefaultState(),

  mutations: {
    resetState(state) {
      Object.assign(state, getDefaultState());
    },
    setEmails(state, payload) {
      state.emails = payload;
    },
    setMaxEmails(state, payload) {
      state.maxEmails = payload;
    },
  },

  actions: {
    async getEmails({ commit }) {
      try {
        commit('setLoading', true, { root: true });

        const { data } = await BillingDashboard.getEmails();

        commit('setEmails', data.data.emails);
        commit('setMaxEmails', data.data.max_emails);
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
        if (ex.response?.data) console.error(ex.response.data);
      }
    },

    async addEmail({ commit, state }, email) {
      try {
        commit('setLoading', true, { root: true });

        const { data } = await BillingDashboard.addEmail({ email });

        commit('setEmails', [...state.emails.filter((x) => x.email != email), data.data]);
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
        if (ex.response?.data) console.error(ex.response.data);
      }
    },

    async deleteEmail({ commit, state }, id) {
      try {
        commit('setLoading', true, { root: true });

        const { data } = await BillingDashboard.deleteEmail(id);

        commit(
          'setEmails',
          state.emails.filter((e) => e.store_subscription_email_notification_id != id)
        );
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
        if (ex.response?.data) console.error(ex.response.data);
      }
    },
  },
};
